import Box from "@material-ui/core/esm/Box";
import clsx from 'clsx';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValueLoadable } from 'recoil';
import { getUnpaidInvoicesForCustomer } from 'api/invoices/getUnpaidInvoicesForCustomer';
import { DownloadButton } from 'components/Button';
import TabButton from 'components/Button/TabButton';
import { LargeHeader, Subtitle } from 'components/Text';
import InvoiceType from 'constants/invoiceTypes';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import checkLoadable from 'utils/recoil/checkLoadable';
import AllInvoices from './AllInvoices/AllInvoices';
import InvoiceDownloadDialog from './InvoiceDownload/invoiceDownloadDialog';
import useStyles from './InvoiceStyles';
import UnpaidInvoices from './UnpaidInvoices/UnpaidInvoices';
import InfoOutlined from "@material-ui/icons/esm/InfoOutlined";
import { LIGHT_PRIMARY } from 'constants/colors';
import FinancialSecurityDepositDisplay from './FinancialSecurityDeposit/FinancialSecurityDepositDisplay';
import { getCustomerDeposit } from 'api/deposit/getCustomerDeposit';
export default function Invoices() {
  const {
    t
  } = useTranslation();
  const {
    active,
    tab
  } = useStyles();
  const [invoiceType, setInvoiceType] = useState(InvoiceType.unpaid);
  const {
    customer
  } = useCurrentCustomer();
  const loadableUnpaidInvoices = useRecoilValueLoadable(getUnpaidInvoicesForCustomer(customer?.id));
  const {
    contents: unpaidInvoices
  } = checkLoadable(loadableUnpaidInvoices);
  const isUnpaidType = invoiceType === InvoiceType.unpaid;
  const [isDownloadDialogOpen, setIsDownloadDialogOpen] = useState(false);
  const depositLoadable = useRecoilValueLoadable(getCustomerDeposit(customer?.id));
  const {
    contents: deposit
  } = checkLoadable(depositLoadable);
  const InvoiceButtons = /*#__PURE__*/React.createElement(Box, {
    style: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TabButton, {
    className: clsx(tab, isUnpaidType && active),
    onClick: () => {
      setInvoiceType(InvoiceType.unpaid);
    }
  }, /*#__PURE__*/React.createElement(Subtitle, null, t('invoices.unpaid', {
    invoicesCount: unpaidInvoices?.totalResults ?? 0
  }))), /*#__PURE__*/React.createElement(TabButton, {
    className: clsx(tab, !isUnpaidType && active),
    onClick: () => {
      setInvoiceType(InvoiceType.all);
    }
  }, /*#__PURE__*/React.createElement(Subtitle, null, t('invoices.all')))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/React.createElement(DownloadButton, {
    onClick: () => {
      setIsDownloadDialogOpen(true);
    }
  }, t('invoices.invoice_download.report_download'))));
  const content = isUnpaidType ? /*#__PURE__*/React.createElement(UnpaidInvoices, null) : /*#__PURE__*/React.createElement(AllInvoices, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LargeHeader, null, t('invoices.invoices')), deposit && /*#__PURE__*/React.createElement(FinancialSecurityDepositDisplay, {
    deposit: deposit
  }), /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, InvoiceButtons, content, /*#__PURE__*/React.createElement(InvoiceDownloadDialog, {
    open: isDownloadDialogOpen,
    customerId: customer?.id,
    onClose: () => setIsDownloadDialogOpen(false)
  })), /*#__PURE__*/React.createElement(Box, {
    bgcolor: LIGHT_PRIMARY,
    padding: '2rem',
    borderRadius: '5px',
    fontSize: 'medium',
    position: 'relative',
    textAlign: 'center'
  }, /*#__PURE__*/React.createElement(InfoOutlined, {
    style: {
      position: 'absolute',
      top: '1rem',
      left: '1rem'
    }
  }), t('invoices.payment_invoice_customer_information_box')));
}